interface OverlayProps {
  show: boolean
  onClick?: () => void
}

export const Overlay = ({ show, onClick }: OverlayProps) => {
  return (
    <div
      id="overlay"
      role="button"
      tabIndex={0}
      aria-label="Fechar modal"
      className={`${
        show ? 'opacity-75' : 'hidden'
      } z-[10000] inset-0 fixed w-screen h-screen transition-all duration-300 ease-out bg-restructure-background-neutral-12 overflow-hidden overscroll-contain`}
      onClick={
        show
          ? (e) => {
              e.stopPropagation()
              if (onClick) onClick()
            }
          : undefined
      }
      onKeyDown={
        show && onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onClick()
              }
            }
          : undefined
      }
    />
  )
}
